function audioObserver(swiper) {
	const albumTracklist = document.getElementById('album-tracklist');
	const albumTracklistMobile = document.getElementById(
		'album-tracklist-mobile',
	);
	const albumPreview = document.getElementById('album-preview-wrapper');
	const transitionTime = 800;
	let previewImg = document.getElementById('album-preview');

	function setAlbumData() {
		const activeSlide = document.getElementsByClassName(
			'swiper-slide-active',
		)[0];

		albumPreview.dataset.numberOfSongs = JSON.parse(
			activeSlide.dataset.songsList,
		).length;
		albumPreview.dataset.listSongs = activeSlide.dataset.songsList;
		albumPreview.dataset.albumId = JSON.parse(activeSlide.dataset.albumId);
		albumPreview.dataset.albumTitle = activeSlide.dataset.albumTitle;
		setAlbumPreviewTitle();
	}

	function setFirstActiveSong() {
		albumPreview.dataset.activeSong = 1;
	}

	function setLastActiveSong() {
		albumPreview.dataset.activeSong = albumPreview.dataset.numberOfSongs;
	}

	function setActualActiveSong(newActiveSongIndex) {
		Array.from(albumTracklist.childNodes).forEach((track, index) => {
			track.classList.remove('active-song');
			if (newActiveSongIndex === index + 1) track.classList.add('active-song');
		});
		Array.from(albumTracklistMobile.childNodes).forEach((track, index) => {
			track.classList.remove('active-song');
			if (newActiveSongIndex === index + 1) track.classList.add('active-song');
		});
	}

	function setAlbumPreviewTitle() {
		const albumTitleNode = document.getElementById('album-preview-title');
		const albumTitleMobileNode = document.getElementById(
			'album-preview-title-mobile',
		);
		
		const albumTitle = JSON.parse(albumPreview.dataset.albumTitle);
		
		// Разбиваем название на две строки для первого альбома
		let titleWithSpan;
		if (albumTitle.includes('Far&High')) {
			titleWithSpan = `<span>Far&High</span><span>& pizzaaftersex</span>`;
		} else {
			titleWithSpan = `<span> ${albumTitle} </span>`;
		}
		
		albumTitleNode.innerHTML = titleWithSpan;
		albumTitleMobileNode.innerHTML = titleWithSpan;
	}

	function setTrackList() {
		const songsList = JSON.parse(albumPreview.dataset.listSongs);
		const trackListNode = document.getElementById('album-tracklist');
		const trackListMobileNode = document.getElementById(
			'album-tracklist-mobile',
		);

		trackListNode.innerHTML = '';
		trackListMobileNode.innerHTML = '';
		Array.from(songsList).forEach((track) => {
			const song = document.createElement('li');
			song.classList.add('albums__item-song');
			song.innerText = track.title;
			trackListNode.appendChild(song.cloneNode('true'));
			trackListMobileNode.appendChild(song);
		});
	}

	function setPlayerSongTitle() {
		const playerSongTitleNode = document.getElementById('music');
		const songNumber = albumPreview.dataset.activeSong;
		let songTitle = '';
		JSON.parse(albumPreview.dataset.listSongs).map((song) => {
			if (song.id == songNumber) songTitle = song.title;
		});
		playerSongTitleNode.innerText = songTitle;
	}

	async function setPlayerSongPath() {
		const audio = document.getElementById('audio-file');

		const activeSongNumber = document.getElementById('album-preview-wrapper')
			.dataset.activeSong;

		const activeAlbumId = document.getElementById('album-preview-wrapper')
			.dataset.albumId;

		const songPath = `/assets/audio/album-${activeAlbumId}/${activeSongNumber}.mp3`;
		try {
			audio.src = songPath;
			audio.play();
		} catch (error) {
			console.log(error);
		}
	}

	function changeAlbumNext() {
		swiper.slideNext();
		transitionAlbumPreviewImg();
		setAlbumData();
	}

	function changeAlbumPrev() {
		swiper.slidePrev();
		transitionAlbumPreviewImg();
		setAlbumData();
	}

	function changeActiveSong(newActiveSongIndex) {
		const numberOfSongs = albumPreview.dataset.numberOfSongs;

		if (newActiveSongIndex > numberOfSongs) {
			changeAlbumNext();
			setTrackList();
			setFirstActiveSong();
			setPlayerSongTitle();
			setPlayerSongPath();
			return;
		}

		if (newActiveSongIndex < 1) {
			changeAlbumPrev();
			setTrackList();
			setLastActiveSong();
			setPlayerSongTitle();
			setPlayerSongPath();
			return;
		}
		setActualActiveSong(newActiveSongIndex);
		setPlayerSongTitle();
		setPlayerSongPath();
	}

	function transitionAlbumPreviewImg() {
		let nextPreviewImgTEST = document.getElementById('album-preview-next');
		if (nextPreviewImgTEST) nextPreviewImgTEST.remove();
		previewImg = document.getElementById('album-preview');
		const albumPreviewWrapper = document.getElementById(
			'album-preview-wrapper',
		);

		const appendPreviewImg = document.createElement('img');
		if (!previewImg) {
			albumPreviewWrapper.appendChild(appendPreviewImg);
		}

		const appendNextPreviewImg = document.createElement('img');
		appendPreviewImg.id = 'album-preview';
		appendNextPreviewImg.id = 'album-preview-next';
		albumPreviewWrapper.appendChild(appendNextPreviewImg);

		const nextPreviewImg = document.getElementById('album-preview-next');
		let imgSrc = document.getElementsByClassName('swiper-slide-active')[0]
			.children[0].src;
		nextPreviewImg.src = imgSrc;

		window.requestAnimationFrame(() => {
			if (previewImg) {
				previewImg.style.setProperty(
					'transition',
					`transform ${transitionTime}ms ease-in-out`,
				);
				previewImg.style.setProperty(
					'-webkit-transition',
					`transform ${transitionTime}ms ease-in-out`,
				);
				previewImg.style.setProperty(
					'-moz-transition',
					`transform ${transitionTime}ms ease-in-out`,
				);
				previewImg.style.setProperty(
					'-o-transition',
					`transform ${transitionTime}ms ease-in-out`,
				);
				previewImg.style.setProperty('transform', 'translateX(-100%)');
			}
		});

		window.requestAnimationFrame(() => {
			nextPreviewImg.style.setProperty(
				'transition',
				`transform ${transitionTime}ms ease-in-out`,
			);
			nextPreviewImg.style.setProperty(
				'-webkit-transition',
				`transform ${transitionTime}ms ease-in-out`,
			);
			nextPreviewImg.style.setProperty(
				'-moz-transition',
				`transform ${transitionTime}ms ease-in-out`,
			);
			nextPreviewImg.style.setProperty(
				'-o-transition',
				`transform ${transitionTime}ms ease-in-out`,
			);
			setTimeout(() => {
				nextPreviewImg.style.setProperty('transform', 'translateX(-100%)');
			}, 0);
		});

		setTimeout(() => {
			previewImg.remove();
			nextPreviewImg.style.removeProperty('transition');
			nextPreviewImg.style.removeProperty('transform');
			nextPreviewImg.id = 'album-preview';
		}, transitionTime);
	}

	const config = { attributes: true, childList: true, subtree: false };
	const callback = (mutationList, observer) => {
		for (const mutation of mutationList) {
			if (mutation.type === 'childList') {
			} else if (mutation.type === 'attributes') {
				changeActiveSong(Number(albumPreview.dataset.activeSong));
			}
		}
	};
	const observer = new MutationObserver(callback);
	observer.observe(albumPreview, config);
}

export default audioObserver;
